// @flow
import * as React from 'react'
import Button, { type Props } from './Button'

export default class SubmitButton extends React.Component<Props> {
  static defaultProps = Button.defaultProps

  render = () => {
    return (
      <Button {...this.props} type="submit">
        {this.props.children}
      </Button>
    )
  }
}
